import AccountRoleType from './enums/AccountRoleType';

/**
 * Роли, которые администратор выдаёт в карточке пользователя.
 */
export const EDITABLE_ROLES = [
    { role: AccountRoleType.USER, label: 'Пользователь' },
    { role: AccountRoleType.EXECUTOR, label: 'Исполнитель' },
    { role: AccountRoleType.ADMIN, label: 'Администратор' },
];

/**
 * Роли, источник истины для которых — AD (группы из config/ldap.php). Карточка
 * показывает их, но не выдаёт и не снимает: сервер их из формы не принимает,
 * а при сохранении оставляет как есть (UsersService::DIRECTORY_ONLY_ROLES).
 */
export const DIRECTORY_ROLES = [
    { role: AccountRoleType.INVENTORY_MANAGER, label: 'Инвентаризация (Менеджер)' },
    { role: AccountRoleType.INVENTORY_VIEWER, label: 'Инвентаризация (Наблюдатель)' },
];

/**
 * Роли пользователя, разложенные для карточки.
 *
 * editable уходит в форму и обратно на сервер; readonly только показывается. Роль,
 * которой фронт не знает, тоже только показывается — с запасной подписью: отправить
 * её сервер не даст, а выбросить молча значило бы спрятать от администратора факт.
 *
 * @param {Array<{role: number}>} roles
 * @returns {{editable: Array<{role: number, label: string}>, readonly: Array<{role: number, label: string}>}}
 */
export function splitUserRoles(roles) {
    const editable = [];
    const readonly = [];

    (roles ?? []).forEach(({ role }) => {
        const own = EDITABLE_ROLES.find((item) => item.role === role);

        if (own) {
            editable.push({ ...own });

            return;
        }

        const directory = DIRECTORY_ROLES.find((item) => item.role === role);

        readonly.push(directory ? { ...directory } : { role, label: `Роль ${role}` });
    });

    return { editable, readonly };
}
